module.exports = __webpack_public_path__ + "img/user.f02ea742.svg";